module.exports = __webpack_public_path__ + "img/17.a05f4311.jpg";